import * as f from './_cmFTH';

import * as _hm from './_hf';
import * as ht from './_ht';
import * as ihd from 'src/ihd';

export const itl_60z = () => ({ // 新規登録を考慮し、毎回新規生成
  _60rz: {},
  _601s: [],
}) as ht.dz;

export const crt_60z = async () => {
  const __60z = itl_60z();
  _hm.udtDz(__60z._60rz, {
    ... ihd.i('_60r'),
  });
  __60z._601s = [];
  return __60z;
};

export const load_60rLsAsync = async (
) => {
  const _cdn = f.vdd(true, false);
  const _ls = await f.loadLsAsync({
    tgt: '_60rs',
    cdn: _cdn,
    fld: '*',
  });
  //hf.l(`_cv_60 33: ${hf.s(_ls)}`);
  return _ls;
};

export const load_601AsAsync = async ( pz: {
  dates?: ht.ls,
  yearMth?: ht.s,
  dateStt?: ht.s,
  dateEnd?: ht.s,
} ) => {
  _hm.logOst(`_cv_60___Mz.load_601AsAsync -> _hd_60.grtPzForLoad_601Ps`);
  let _cdn = f.vdd(true, false);
  if (pz.dates) _cdn += ` AND _icn IN (${_hm.join(pz.dates, ',', `'`)})`;
  if (pz.yearMth) _cdn += ` AND _icn LIKE '${pz.yearMth}%'`;
  if (pz.dateStt) _cdn += ` AND _icn >= '${pz.dateStt}'`;
  if (pz.dateEnd) _cdn += ` AND _icn <= '${pz.dateEnd}'`;
  //hf.l(`_cv_61_Mz 47: ${_cdn}`);
  const _ls = await f.loadLsAsync({
    tgt: '_601s',
    cdn: _cdn,
    fld: '_icn',
  });
  return _ls.map( (_dz: ht.dz) => _dz._icn);
};

export const load_60rDzAsync = async (pz: {
  _60r_fst: ht.n,
}) => {
  const _cdn = f.vdd(true, false) + ` AND _fst=${pz._60r_fst}`;
  //hf.l(`_cv_60 55: ${_cdn}`);
  const _dz = await f.loadDzAsync({
    tgt: '_60rs',
    cdn: _cdn,
    lwrz: {
      _601s: {
        tgt: '_601s',
        cdn: f.vdd(false, false) + ` AND _601_60r1k = {_60r_key}`,
        rlcz: {
          _60r_key: '_60rs._key',
        },
      },
    }
  });
  //hf.l(`_cv_60 70: ${hf.s(_dz)}`);
  return {
    _60rz: { ... _dz, cldz: undefined },
    _601s: _dz.cldz?._601s ?? [],
  };
};

export const save_60rDzAsync = async (pz: {
  _60z: ht.dz,
  sPz?: ht.dz,
}) => {
  const _dz = await f.ugdDzAsync({
    tgt: '_60rs',
    dmn: 0,
    dz: {
      ... pz._60z._60rz,
    },
    lwrz: {
      _601s: {
        tgt: '_601s',
        dmn: 0,
        ls: pz._60z._601s,
/*
        rlcz: {
          _601_60r1k: '_60rs._key',
        }
*/
        udtz: {
          _601_60r1k: '_60rs._key',
        }
      },
    }
  });
  return {
    _60rz: { ... _dz, cldz: undefined },
  };
};
